import React, { useState } from "react";

const SizeChart = () => {
  const [isOpen, setIsOpen] = useState(false);

  const data = [
    { size: "XS", shoulder: "16.00", chest: "37.00", length: "26.00" },
    { size: "S", shoulder: "17.00", chest: "39.50", length: "27.00" },
    { size: "M", shoulder: "18.00", chest: "42.50", length: "28.00" },
    { size: "L", shoulder: "18.50", chest: "45.50", length: "29.00" },
    { size: "XL", shoulder: "19.50", chest: "48.50", length: "30.00" },
    { size: "2XL", shoulder: "20.50", chest: "51.50", length: "31.00" },
    { size: "3XL", shoulder: "22.00", chest: "54.50", length: "32.00" },
  ];


  return (
    <div className="size-chart">
      <h2
        className="section-title" 
        style={{ cursor: "pointer", userSelect: "none", marginBottom:"0px" , fontSize:"18px" , marginLeft:"0px" }}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-controls="size-table"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            setIsOpen(!isOpen);
          }
        }}
      >
        Size Guide <span>(in Inches)</span> {isOpen ? "▲" : "▼"}
      </h2>

      {isOpen && (
        <div className="table-wrapper" id="size-table" style={{marginTop:"12px"}}>
          <table className="size-table">
            <thead>
              <tr>
                <th>SIZE</th>
                <th>SHOULDER</th>
                <th>CHEST</th>
                <th>LENGTH</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{row.size}</td>
                  <td>{row.shoulder}</td>
                  <td>{row.chest}</td>
                  <td>{row.length}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SizeChart;
